import React from "react";
import "./newsletter-card.m.css";
import AddWithCircle from "../../atoms/other-icons/AddWithCircle";
import Clock from "../../atoms/other-icons/Clock";

const NewsletterCard = ({ item, onSignup, isSelected }) => {
  const { title, summary, id, tag_name, duration } = item;

  return (
    <div styleName={`wrapper ${isSelected.includes(id) ? "selected-card" : ""}`}>
      <div>
        <h2>{title}</h2>
        <p>{summary}</p>
      </div>
      <div>
        <div styleName="time-preview">
          <div styleName="time">
            <Clock color="black" height="14px" width="14px" /> {duration}
          </div>
        </div>
        <button onClick={() => onSignup(id, tag_name, title)}>
          Sign up <AddWithCircle height="18px" width="18px" styleName="icon" />
        </button>
      </div>
    </div>
  );
};

export default NewsletterCard;
